import { createSlice } from "@reduxjs/toolkit"

const initialState = {
    open : false,
    cb : null,
    texto : "",
}

export function novaConfirmacao (texto, cb) {
    return {
        texto, cb
    }
}

export const confirmationSlice = createSlice({
    name: "confirmation",
    initialState,
    reducers: {
        yes : (state) => {
            state.open = false
            state.texto = ""
            state.cb = null
        },
        no : (state) => {
            state.open = false
            state.texto = ""
            state.cb = null
        },
        startConfirmacao : (state, action) => {
            state.open = true
            state.texto = action.payload.texto
            state.cb = action.payload.cb
        },
        triggerConfirmar() {}
    }
})


export const {
    yes,
    no,
    startConfirmacao,
    triggerConfirmar
} = confirmationSlice.actions

export default confirmationSlice.reducer;